// extracted by mini-css-extract-plugin
module.exports = {"tabsNews":"tabsNews-j7PlI1KP","cut":"cut-21LAx5Y0","tabs":"tabs-5jIL6oM9","itis":"itis-eGX74oFh"};